export default __webpack_public_path__ + "static/media/inspired-kraver.e97ab285.svg";